import { type FC, type ReactNode } from "react";
import { Icon } from "../Icon";
import { colors } from "../../styles/sprinkles.css";
import * as styles from "./styles.css";

type Props = {
  isShow?: boolean;
  children: ReactNode;
  headerTitle?: string;
  hasHeaderCloseButton?: boolean;
  onClose?: () => void;
};

export const PopUp: FC<Props> = ({
  isShow = false,
  children,
  headerTitle,
  hasHeaderCloseButton = false,
  onClose,
}) => {
  if (!isShow) return null;

  return (
    <div className={styles.wrapper}>
      <div className={headerTitle ? styles.headerFlexWrapper : styles.headerBlockWrapper}>
        {headerTitle && <div className={styles.headerTitle}>{headerTitle}</div>}
        {hasHeaderCloseButton && (
          <button
            type="button"
            className={styles.headerCloseButton}
            onClick={onClose}
            aria-label="閉じる"
          >
            <Icon name="cross-thin" color={colors.TextMedium} fontSize="18px" />
          </button>
        )}
      </div>
      {children}
    </div>
  );
};
